"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnvContext = void 0;
const react_1 = require("react");
const env_context_1 = require("./env-context");
const useEnvContext = () => (0, react_1.useContext)(env_context_1.EnvContext);
exports.useEnvContext = useEnvContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWVudi1jb250ZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VzZS1lbnYtY29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsWUFBWSxDQUFDOzs7QUFFYixpQ0FBbUM7QUFFbkMsK0NBQTJDO0FBRXBDLE1BQU0sYUFBYSxHQUFHLEdBQUcsRUFBRSxDQUFDLElBQUEsa0JBQVUsRUFBQyx3QkFBVSxDQUFDLENBQUM7QUFBN0MsUUFBQSxhQUFhLGlCQUFnQyJ9